import type { ReactNode } from "react";

import { spinnerOverlay } from "./spinner";

type Props = {
  children?: ReactNode;
};

export const OverlaysProvider = ({ children }: Props) => {
  return (
    <>
      {children}
      <spinnerOverlay.Viewport />
    </>
  );
};
